export default __webpack_public_path__ + "static/media/hht2_ep12_timeline_q03_b.1b52b8c6.png";